<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097'"
            label="支付渠道"
          >
            <el-select v-model="form.serviceImplName" placeholder="请选择支付渠道">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in payOption"
                :key="item.serviceImplName"
                :label="item.channelName"
                :value="item.serviceImplName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>


        <template slot="buttonArea">
          <el-button :loading="loading" type="primary" @click="generateStatisticsToday" size="small">
          刷新今日</el-button>
        </template>


        <template slot="tableColumn">
          <!-- <el-table-column
            width="50"
            prop="id"
            label="id"
            align="center"
          ></el-table-column> -->

          <el-table-column
            width="120"
            prop="statisticsDate"
            label="日期"
            :formatter="$formatter.formatDate"
            align="center"
          ></el-table-column>
          <el-table-column
            width="180"
            prop="updateTime"
            label="刷新时间"
            align="center"
          ></el-table-column>


          <el-table-column
            width="90px"
            prop="channelId"
            label="channel"
            align="center"
          ></el-table-column>
          <el-table-column
            width="150px"
            prop="channelName"
            label="渠道名"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>


          <el-table-column
            width="140px"
            prop="paymentAmount"
            :formatter="$formatter.FenToYuan"
            label="交易金额"
            align="center"
          ></el-table-column>

          <el-table-column
            width="80px"
            prop="paymentFeeRate"
            label="费率"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="paymentFee"
            :formatter="$formatter.FenToYuan"
            label="渠道成本费"
            align="center"
          ></el-table-column>
          
          <el-table-column
            width="80px"
            prop="paymentCount"
            label="交易总数"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="paymentCountSuccess"
            label="交易成功数"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100px"
            prop="paymentCountSuccessRate"
            label="交易成功率"
            align="center"
          ></el-table-column>


          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="140px"
            prop="merFee"
            :formatter="$formatter.FenToYuan"
            label="商户手续费"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="calBalance"
            :formatter="$formatter.FenToYuan"
            label="利润"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="realBalance"
            :formatter="$formatter.FenToYuan"
            label="实际余额"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="realBalanceTime"
            label="余额更新时间"
            align="center"
          ></el-table-column>


        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/statistics-channel/listStatistics",
      payOption: [],
      loading: false,
      form: {
        channelId: "",
        startDate: "",
        endDate: "",
      },
      timeDate: [],
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');; 
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },

    generateStatisticsToday() {
      this.$axios.get('/statistics-channel/generateStatisticsToday', { params: {} })
      .then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '提示',
            message: res.msg,
            type: 'success',
          })

          this.$bus.$emit('refresh') //通知刷新

          this.closeDialog()
        } else {
          this.$notify.error({
            title: '提示',
            message: res.msg,
          })
        }
      })
    }

  },

  created() {
    this.$axios
      .get('/routeChannelInfo/selectByCondition', { params: {} })
      .then(res => {
        res.data.map(item => {
          if (item.productId == 110) {
            this.payOption.push(item)
          }
        })
      })
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.el-form-item {
  margin-bottom: 5px;
}
</style>